module.exports = import("https://kit.fontawesome.com/2e0b382a53.js");;